module.exports = __webpack_public_path__ + "rabbit.612eaa5ca25e60c81831.gif";


//////////////////
// WEBPACK FOOTER
// /var/www/capzool/temp/src/assets/images/rabbit.gif
// module id = ../../../../../src/assets/images/rabbit.gif
// module chunks = styles